// Carries the industry a visitor self-identified by landing on an industry ad
// page (e.g. /ai-for-restaurants) through /register into Onboarding step 1, so
// we stop asking a question the landing page already answered.
//
// Keys match what Onboarding stores — `ind.slug.replace(/-/g, '_')` — for the
// industries seeded by agents/management/commands/seed_industries.py. Anything
// not in that set is ignored rather than written, so a stale or hand-edited
// ?industry= value can never put Onboarding into a state its own grid can't
// represent. Note there is no accounting industry yet, so /ai-for-accountants
// intentionally has no key and still asks.

const KEY = 'pendingIndustry'

const VALID = new Set([
  'restaurant',
  'food_truck',
  'contractor',
  'salon',
  'real_estate',
  'retail',
  'fitness',
  'dental',
  'law',
  'marketing_agency',
  'ecommerce',
  'other',
])

export function isValidIndustry(value: string | null | undefined): boolean {
  return typeof value === 'string' && VALID.has(value)
}

export function setPendingIndustry(industry: string): void {
  if (typeof window === 'undefined' || !isValidIndustry(industry)) return
  try {
    sessionStorage.setItem(KEY, industry)
  } catch {
    // Safari private mode / storage disabled — the industry step just asks.
  }
}

export function consumePendingIndustry(): string | null {
  if (typeof window === 'undefined') return null
  try {
    const value = sessionStorage.getItem(KEY)
    if (value) sessionStorage.removeItem(KEY)
    return isValidIndustry(value) ? value : null
  } catch {
    return null
  }
}
